module.exports = __webpack_public_path__ + "static/img/logo.d48dc29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/logo.jpg
// module id = fYkw
// module chunks = 3